import React from 'react';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import {
    Edit,
    TextInput,
    required,
    SimpleForm,
    ImageInput,
    ImageField,
} from 'react-admin';
import { ImageInformations } from '../../components';

export default props => (
    <Permission permission={PERMISSIONS.ADMIN}>
        <Edit {...props} title="Editar serviço" >
            <SimpleForm sx={{ maxWidth: 600 }}>
                <TextInput source="name" label="Nome" validate={required("Nome é obrigatório")} sx={{ minWidth: 300 }} />
                <TextInput source="description" label="Descrição" sx={{ minWidth: 300 }} />
                <ImageInput source="imagefile" label="Imagem" accept={{ 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] }}>
                    <ImageField source="src" label="Imagem" />
                </ImageInput>
                <ImageInformations position={-20}/>
            </SimpleForm>
        </Edit>
    </Permission>
);

